import i18n from 'services/base/i18n';

export default {
  // Text describing for the download
  download: () => i18n.pgettext('Pages|Network Status', 'DOWNLOAD'),

  // Text describing for the upload
  upload: () => i18n.pgettext('Pages|Network Status', 'UPLOAD'),

  // Text describing for devices that are connected to the pangolin
  connected: () => i18n.pgettext('Pages|Network Status', 'CONNECTED'),

  // Label for how many devices are connected. Because of coloring and font sizing, it will always look something like "12 Devices" so there is no %d here. Please provide the correct plural form anyway.
  deviceUnits: (value: number) => i18n.npgettext('Pages|Network Status', 'Device', 'Devices', value),
};
